import { render, staticRenderFns } from "./RaiseIssueModalComponent.vue?vue&type=template&id=012391d6"
import script from "./RaiseIssueModalComponent.vue?vue&type=script&lang=js"
export * from "./RaiseIssueModalComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports